import { API_URL, buildMockPromise, isMocksEnabled } from "./helpers";
import { MyAssignedCheckTypesResponse } from "./Actor";
import { useQuery } from "react-query";
import { useAppContext } from "../AppProviders";
import { useActorInfoQuery } from "./UsersApi";

const myAssignedCheckTypesMock: MyAssignedCheckTypesResponse = {
  has_task: true,
  check_type_uuids: ["a52d200f-bc77-4656-b1f9-56bb07418b76"],
  workflow_step_names: ["PostsManualRate"],
};

export function useMyAssignedCheckTypes() {
  const { requestApi } = useAppContext();
  const { data: actorInfo } = useActorInfoQuery(true);
  const actor_uuid = actorInfo?.actor_uuid ?? null;

  return useQuery<MyAssignedCheckTypesResponse>(
    ["myAssignedCheckTypes", actor_uuid],
    async () => {
      if (isMocksEnabled()) {
        return buildMockPromise(myAssignedCheckTypesMock);
      }
      const response = await requestApi.get(
        `${API_URL}/my_assigned_check_types`
      );
      return response.data;
    },
    {
      enabled: !!actor_uuid,
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
    }
  );
}
